export const APP_NAME = process.env.VUE_APP_NAME;
export const APP_VERSION = process.env.VUE_APP_VERSION;
export const BOOKHOSID = '057101';
export const HOSID = '3308000001';
export const TEE3 = 'v.diandianys.com';
/**
 * 基础参数
 * @type {{channel: string, format: string, oper: string, random: string, spid: string}}
 */
export const BASE_PARAMS = {
    'channel': '4',
    'format': 'JSON',
    'oper': '127.0.0.1',
    'random': '1234',
    'spid': '1001',
    version: '4.8.3'
}

export const PASSWORD = "aAr9MVS9j1";

/**
 * 主题色
 * @type {string}
 */
export const MAIN_COLOR = '#0893FF';

/**
 * 左侧背景色
 * @type {string}
 */
export const LEFT_BG = '#001529';

/**
 * 视频播放器控制按钮
 * @type {*[]}
 */
export const VIDEO_CONTROLS = []
/**
 * 续方类型
 * @type {*[]}
 */
export const RENEWAL_TYPE = [
    {name: '本院续方', id: 'INSIDE'},
    {name: '外院续方', id: 'EXTERNAL'},
]

/**
 * 慢病续方-订单状态
 * @type {*[]}
 */
export const RENEWAL_ORDER_STATUS = [
    {id: 'APPLYING', name: '申请中', desc: '请耐心等待医生处理，医生可能会联系您。'},
    {id: 'WAITPAY', name: '待支付', desc: '医生已为您续方，请尽快支付处方费用'},
    {id: 'WAITTAKE', name: '待取药', desc: '已支付费用，您可以到院取药或选择配送到家'},
    {id: 'CANCEL', name: '已取消', desc: ''},
    {id: 'CONTINUATION', name: '已续方'},
    {id: 'SHIPPING', name: '配送中', desc: '药品正在为您配送中'},
    {id: 'COMPLATE', name: '已完成', desc: '祝您健康常伴'}
];
/**
 * 网络诊间-门诊类别
 * @type {*[]}
 */
export const ONLINE_MZLB = [
    {value: '1', label: '专家门诊'},
    {value: '2', label: '普通门诊'}
]

/**
 * 网络诊间订单状态映射按钮
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_DDZT_BTN = {
    '0': [],
    '1': ['提醒进入诊间', '接诊'],
    '2': ['查看资料']
}

/**
 * 网络诊间订单状态按钮
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_BTN_MAP = {
    '提醒进入诊间': {type: 'app_btn_default'},
    '接诊': {type: 'app_btn_primary'},
    '查看资料': {type: 'app_btn_default'}
}
/**
 * 慢病续方-药品类型
 * @type {{"1": string, "2": string}}
 */
export const RENEWAL_CHUFANG_TYPE = {
    '1': '西药药品',
    '0': '中药药品'
}
/**
 * 会诊类型
 * @type {string[]}
 */
export const CONSULTATION_TYPE = [
    '名医会诊', '急会诊', '多科会诊', 'ICU会诊', '护理会诊'
];
/**
 * 会诊辅助诊断类型
 * @type {string[]}
 */
export const CONSULTATION_AUXILIARYDIAGNOSE = ['影像', '病理'];

/**
 * 婚姻状态
 * @type string[]
 */
export const MARITALSTATUS = ['未婚', '已婚', '离异', '未知'];
/**
 * 性别
 * @type {string[]}
 */
export const SEX = ['男', '女', '未知'];

/**
 * 会诊状态
 * @type {*[]}
 */
export const CONSULTATION_STATUS = [
    {name: '待处理', id: '1', service: 'smarthos.consult.group.waithandle.list'},
    {name: '待会诊', id: '2', service: 'smarthos.consult.group.waitvideo.list'},
    {name: '已完成', id: '3', service: 'smarthos.consult.group.comment.list'},
    {name: '已取消', id: '4', service: 'smarthos.consult.group.cancel.list'}
];
/**
 * 远程会诊-doc-tabs
 * @type {*[]}
 */
export const CONSULTATION_DOC_STATUS = [
    {name: '发起的', id: '1', service: 'smarthos.consult.group.waithandle.list'},
    {name: '收到的', id: '2', service: 'smarthos.consult.group.waitvideo.list'},
    {name: '已完成', id: '3', service: 'smarthos.consult.group.comment.list'},
    {name: '已取消', id: '4', service: 'smarthos.consult.group.cancel.list'}
];
/**
 *
 * @type {{评价: {type: string}, 取消申请: {type: string}, 进入诊间: {type: string}, 补充资料: {type: string}}}
 */
export const CONSULTATION_BTN = {
    '取消申请': {type: 'danger'},
    '提交': {type: 'primary'},
    '进入诊间': {type: 'primary'},
    '确认补充': {type: 'primary'},
    '完成会诊': {type: 'primary'},
    '评价': {type: 'primary'},
    '提交会诊情况': {type: 'primary'},
    '申请转诊': {type: 'primary'},
    '提交修改': {type: 'primary'},
    '再次申请': {type: 'primary'}
};
/**
 * 转诊类型
 * @type {string[]}
 */
export const REFERRAL_TYPE = [{name: '门诊转诊', id: 'outpatient', value: 'OUT_PATIENT'}, {
    name: '住院转诊',
    id: 'hospitalization',
    value: 'IN_HOSPITAL'
}];

/**
 * 转诊详情按钮
 * @type {{取消申请: {type: string}, 提交: {type: string}}}
 */
export const REFERRAL_BTN = {
    '取消申请': {type: 'danger'},
    '提交': {type: 'primary'},
    '审核通过': {type: 'primary'},
    '门诊转诊安排': {type: 'primary'},
    '住院转诊安排': {type: 'primary'},
    '确认补充': {type: 'primary'},
    '再次申请': {type: 'primary'}
};
/**
 * 统计类型
 * @type {*[]}
 */
export const STATISTICS_TYPE = [
    {id: 'init', name: '发起的', value: 'DELIVER'},
    {id: 'accept', name: '接收到', value: 'RECEIVED'}
];
/**
 * 转诊状态
 * @type {*[]}
 */
export const REFERRAL_STATUS = [
    {name: '待处理', id: ['2']},
    {name: '已完成', id: ['4']},
    {name: '已取消', id: ['-1', '-2']}
];

/**
 * 推流地址(阿里云)
 * @type {string}
 */
export const PUSH_DOMAIN = 'vstream.diandianys.com';
/**
 * 推流域名（腾讯云）
 * @type {string}
 */
export const PUSH_TX_DOMAIN = '32457.livepush.myqcloud.com';


/**
 * 推流鉴权（阿里云）
 * @type {string}
 */
export const PUSH_KEY = '4mlRw7a018';

/**
 * 推流鉴权（腾讯云）
 * @type {string}
 */
export const PUSH_TX_KEY = 'be168ab32110efbddccd14c84aad9ddd';


/**
 * 播流地址
 * @type {string}
 */

export const PLAY_DOMAIN = 'vstreamb.diandianys.com';

/**
 * 播流地址(腾讯云)
 * @type {string}
 */

export const PLAY_TX_DOMAIN = 'player.limingwei.name';
/**
 * 播流鉴权
 * @type {string}
 */
export const PLAY_KEY = 'lEMook5xKB';//lEMook5xKB
/**
 * 有效时长
 * @type {number}
 */
export const TIME_LENGTH = 30000 * 60 * 1000;
/**
 * 用户类型
 * @type {{DOC: {name: string, id: string}, NURSE: {name: string, id: string}}}
 */
export const USER_TYPE = {
    DOC: {name: '医生', id: "DOC"},
    NURSE: {name: '护士', id: 'NURSE'},
    AID_DRIVER: {name: '急救中心司机'},
    HEAL_T_ADM: {id: '体检', defaultIndex: '/tj/rili'},
    AID_ADM: {name: '急重症管理员', defaultIndex: '/staff/faqi'},
    AID_E_ADM: {name: '急重症审核员', defaultIndex: '/staff/jieshou'}
};
